import { NavigateFunction, Location } from 'react-router';

export const handleScrollToClass = (
    className: string,
    navigate: NavigateFunction,
    location: Location
): void => {
    const scrollToElement = () => {
        const element = document.querySelector(`.${className}`);
        if (element) {
            const elementPosition =
                element.getBoundingClientRect().top + window.pageYOffset;
            const offset = 100; // Adjust this value if your AppBar height changes
            window.scrollTo({
                top: elementPosition - offset,
                behavior: "smooth",
            });
        }
    };

    // If we're already on the homepage
    if (location.pathname === "/") {
        scrollToElement();
    } else {
        navigate("/", { replace: false });
        // Wait for the page to load, then scroll
        setTimeout(() => {
            scrollToElement();
        }, 300); // Adjust delay if necessary
    }
}; 
